import GamesScreenContent from "../../components/others/games/GamesScreenContent";
import {Helmet} from "react-helmet";
import {buildHelmetTitle} from "../../helpers/SeoHelper";
import SystemAppScreenLayout from "../../components/layouts/SystemAppScreenLayout";
import SystemAppContentLayout from "../../components/layouts/SystemAppContentLayout";

export default function GamesScreen() {
    // Used in index.js to handle Games related content

    // BUILD
    return (
        <div className={"w-full h-[100svh] bg-backgroundLight3 flex justify-start items-center"}>
            {/** META */}
            <Helmet>
                <title>{buildHelmetTitle('Ummia - Jeux')}</title>
                <meta name="description"
                      content="Jeux pédagogiques mathématiques pour développer des réflexes quasi instinctifs." />
            </Helmet>
            {/** CONTENT */}
            <SystemAppScreenLayout>
                <SystemAppContentLayout>
                    <GamesScreenContent />
                </SystemAppContentLayout>
            </SystemAppScreenLayout>
        </div>
    );
}